import React from "react";
// import {Link} from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
import './Header.scss';

import {
    Button,
    Col,
    Container,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row,
    UncontrolledCollapse,
} from "reactstrap";
import * as constants from '../../const/constants';
import {withRouter} from "react-router";
import * as actionCreator from "../../store/domain/auth/action";
// import * as commonFunc from "../../utils/commonFunc";
import {connect} from "react-redux";
import swal from "sweetalert";
import * as actionClassCreator from "../../store/domain/classes/action";
import Logo from '../../assets/img/revamp/vibernets/Vibernets Academy grey.png';
import webConfig from '../../config/WebConfig';
import * as commonFunc from "../../utils/commonFunc";
import {lang, language} from "../../const/language";
import Tooltip from "@material-ui/core/Tooltip";

import {AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler} from '@coreui/react';
import {DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import cornerImage from "../../assets/img/institute/avatar-placeholder.png";
import {ChevronDown, HelpCircle, User, LogOut, Users} from "react-feather";

class DemoNavbar extends React.Component {
    state = {
        collapseClasses: "",
        collapseOpen: false,
        screenSize: window.innerWidth
    };
    onExiting = () => {
        this.setState({
            collapseClasses: "collapsing-out"
        });
    };
    onExited = () => {
        this.setState({
            collapseClasses: ""
        });
    };
    setModalHandler = (str) => {
        if (str === "LOGIN") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
            return;
        }
        if (str === "REG") {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_REG_ROUTE}`);
            return;
        }
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
    };
    logoutHandler = () => {
        swal({
            title: constants.ALERT_TEXT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    commonFunc.removeCookiesValues();
                    this.props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                    // commonFunc.notifyMessage("Logout successfully",1);
                    break;
                default:
                    break;
            }
        });
    };
    routeHandler = (route) => {
        if (route === constants.HOME_INSTITUTE_ROUTE) {
            this.props.selectPagination(null);
            this.props.history.push('/');
        }
        if (route === constants.HOME_MY_CLASS_ROUTE) {
            this.props.selectMyClassPagination(null);
        }
        if (route === constants.HOME_PROFILE_ROUTE) {
        }
        if (route === constants.HOME_COURSE_ROUTE) {

        }

        this.props.history.push({
            pathname: `${route}`,
            state: this.props.userType
        });
    };

    reRouteWithId = (place) => {
        let pathName = this.props.location.pathname;
        let array = pathName.split('/');
        console.log(pathName, array);
        if (array.length > 1) {
            this.props.history.push('/' + place)
        }

        if (this.state.screenSize < 992) {
            document.getElementById('navbar_container').classList.remove('show');
            // document.getElementById('navbar_container').classList.add('collapse navbar-collapse');
        }
    };

    componentDidMount() {
        let headroom = new Headroom(document.getElementById("navbar-main"));
        // initialise
        headroom.init();
    }

    render() {
        let {active, userType, headerTransparent} = this.props;
        userType = this.props.userType;
        return (
            <>
                <header className="header-global ">
                    <Navbar
                        className={`navbar-main navbar-transparent navbar-ligh headroom ${headerTransparent}`}
                        expand="lg"
                        id="navbar-main"
                    >
                        <div className="pl-0 w-100">

                            {this.state.screenSize <= 767 &&
                            <NavItem className={"d-block"}>
                                <Tooltip title='Logo'>
                                    <NavLink
                                        //style={{margin: '0 5rem 0 0'}}
                                        className={``}
                                        onClick={() => this.routeHandler(constants.HOME_INSTITUTE_ROUTE)}>
                                        <img style={{borderRadius: '50%', margin: '0 6rem 0 0'}}
                                             width={'60px'}
                                             src={Logo} alt=""/>
                                    </NavLink>
                                </Tooltip>
                            </NavItem>
                            }

                            <button className="navbar-toggler d-lg-none d-md-none" id="navbar_global">
                                <span className="toggle-ctrl"> <i className="icofont-justify-all"/>
                                </span>
                            </button>
                            <UncontrolledCollapse
                                id={'navbar_container'}
                                toggler="#navbar_global"
                                navbar
                                className={`${this.state.collapseClasses} d-lg-flex d-md-flex`}
                                onExiting={this.onExiting}
                                onExited={this.onExited}

                            >


                                {/*Nav btn section start*/}
                                <Nav
                                    className="d-md-flex flex-row  navbar-nav-hover  align-items-lg-center w-100 "
                                    navbar>

                                    {this.state.screenSize >= 768 &&
                                    <>
                                        <div style={{flex: 1}} className={"d-lg-flex d-md-flex d-none"}>
                                            <NavItem className={"d-block"}>
                                                <Tooltip title='Logo'>
                                                    <NavLink
                                                        // style={{border:'1px solid red'}}
                                                        //style={{margin: '0 5rem 0 0'}}
                                                        className={``}
                                                        onClick={() => this.routeHandler(constants.HOME_INSTITUTE_ROUTE)}>
                                                        <img style={{width:'35%',aspectRatio:"3/1.5"}}
                                                             src={Logo} alt=""/>
                                                    </NavLink>
                                                </Tooltip>
                                            </NavItem>
                                        </div>
                                        {/*<NavItem className={"d-none d-lg-block "}>*/}
                                        {/*    <Tooltip title='Logo'>*/}
                                        {/*        <NavLink*/}
                                        {/*            //style={{margin: '0 5rem 0 0'}}*/}
                                        {/*            className={``}*/}
                                        {/*            onClick={() => this.routeHandler(constants.HOME_INSTITUTE_ROUTE)}>*/}
                                        {/*            <img style={{borderRadius: '50%', margin: '0 6rem 0 0'}}*/}
                                        {/*                 width={'60px'}*/}
                                        {/*                 src={Logo} alt=""/>*/}
                                        {/*        </NavLink>*/}
                                        {/*    </Tooltip>*/}
                                        {/*</NavItem>*/}

                                        <div className={"d-lg-flex d-md-flex d-none align-items-center header-center-container"}>
                                            {/*{*/}
                                            {/*    <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Home Page'>*/}
                                            {/*            <NavLink*/}
                                            {/*                href={"#home"}*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.reRouteWithId("#home")}*/}
                                            {/*            >*/}
                                            {/*                {language[lang].HomePage}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Teachers'>*/}
                                            {/*            <NavLink*/}
                                            {/*                href='#teachersSection'*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.reRouteWithId('#teachersSection')}*/}
                                            {/*            >*/}
                                            {/*                Teachers*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Enrolled Classes'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*/}
                                            {/*                {language[lang].MyClass}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={" d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Enrolled Lessons'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>*/}
                                            {/*                {language[lang].MyLessons}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    //Courses*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={" d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Enrolled Courses'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() =>*/}
                                            {/*                    this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}*/}
                                            {/*            >*/}
                                            {/*                {language[lang].MyCourses}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                            {/*        <Tooltip title='Exams'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>*/}
                                            {/*                {language[lang].Exams}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}


                                            {/*{userType !== 1 && webConfig.instituteType === constants.INSTITUTE ?*/}
                                            {/*    <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                            {/*        <Tooltip title='Teachers'>*/}
                                            {/*            <NavLink*/}
                                            {/*                href='#teachersSection'*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.reRouteWithId('#teachersSection')}*/}
                                            {/*            >*/}
                                            {/*                Teachers*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem> : null*/}
                                            {/*}*/}

                                            {/*{userType !== 1 && <NavItem className="d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                            {/*    <Tooltip title='Contact'>*/}
                                            {/*        <NavLink*/}
                                            {/*            className={`nav-event-btn text-center`}*/}
                                            {/*            onClick={() => this.reRouteWithId('#inquiryForm')}*/}
                                            {/*            href={'#inquiryForm'}*/}
                                            {/*        >*/}
                                            {/*            Contact*/}
                                            {/*        </NavLink>*/}
                                            {/*    </Tooltip>*/}
                                            {/*</NavItem>}*/}

                                            {/*{userType !== 1 && <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                            {/*    <Tooltip title='About'>*/}
                                            {/*        <NavLink*/}
                                            {/*            href={'#aboutUsSection'}*/}
                                            {/*            className={`nav-event-btn text-center`}*/}
                                            {/*            onClick={() => this.reRouteWithId('#aboutUsSection')}*/}
                                            {/*        >*/}
                                            {/*            About*/}
                                            {/*        </NavLink>*/}
                                            {/*    </Tooltip>*/}
                                            {/*</NavItem>}*/}

                                            {/*<NavItem className="d-none d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                            {/*    <Tooltip title='Help'>*/}
                                            {/*        <NavLink*/}
                                            {/*            // href={'#help'}*/}
                                            {/*            className={`nav-event-btn text-center`}*/}
                                            {/*            onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}>*/}
                                            {/*            Help*/}
                                            {/*        </NavLink>*/}
                                            {/*    </Tooltip>*/}
                                            {/*</NavItem>*/}
                                            {
                                                <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>
                                                    <Tooltip title='Home Page'>
                                                        <NavLink
                                                            href={"#home"}
                                                            className={`nav-event-btn text-center`}
                                                            onClick={() => this.reRouteWithId("#home")}
                                                        >
                                                            {language[lang].HomePage}
                                                        </NavLink>
                                                    </Tooltip>
                                                </NavItem>
                                            }
                                            {
                                                userType === 1 &&
                                                <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>
                                                    <Tooltip title='Teachers'>
                                                        <NavLink
                                                            href='#teachersSection'
                                                            className={`nav-event-btn text-center`}
                                                            onClick={() => this.reRouteWithId('#teachersSection')}
                                                        >
                                                            Teachers
                                                        </NavLink>
                                                    </Tooltip>
                                                </NavItem>
                                            }
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Enrolled Classes'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*/}
                                            {/*                {language[lang].MyClass}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={" d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Enrolled Lessons'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>*/}
                                            {/*                {language[lang].MyLessons}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    //Courses*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className={" d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                            {/*        <Tooltip title='Enrolled Courses'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() =>*/}
                                            {/*                    this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}*/}
                                            {/*            >*/}
                                            {/*                {language[lang].MyCourses}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}
                                            {/*{*/}
                                            {/*    userType === 1 &&*/}
                                            {/*    <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                            {/*        <Tooltip title='Exams'>*/}
                                            {/*            <NavLink*/}
                                            {/*                className={`nav-event-btn text-center`}*/}
                                            {/*                onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>*/}
                                            {/*                {language[lang].Exams}*/}
                                            {/*            </NavLink>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </NavItem>*/}
                                            {/*}*/}


                                            {userType !== 1 && webConfig.instituteType === constants.INSTITUTE ?
                                                <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">
                                                    <Tooltip title='Teachers'>
                                                        <NavLink
                                                            href='#teachersSection'
                                                            className={`nav-event-btn text-center`}
                                                            onClick={() => this.reRouteWithId('#teachersSection')}
                                                        >
                                                            Teachers
                                                        </NavLink>
                                                    </Tooltip>
                                                </NavItem> : null
                                            }

                                            {userType !== 1 && <NavItem className="d-lg-flex d-md-flex align-items-center justify-content-center w-100">
                                                <Tooltip title='Contact'>
                                                    <NavLink
                                                        className={`nav-event-btn text-center`}
                                                        onClick={() => this.reRouteWithId('#inquiryForm')}
                                                        href={'#inquiryForm'}
                                                    >
                                                        Contact
                                                    </NavLink>
                                                </Tooltip>
                                            </NavItem>}

                                            {<NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">
                                                <Tooltip title='About'>
                                                    <NavLink
                                                        href={'#aboutUsSection'}
                                                        className={`nav-event-btn text-center`}
                                                        onClick={() => this.reRouteWithId('#aboutUsSection')}
                                                    >
                                                        About
                                                    </NavLink>
                                                </Tooltip>
                                            </NavItem>}

                                            <NavItem className="d-none d-lg-flex d-md-flex align-items-center justify-content-center w-100">
                                                <Tooltip title='Help'>
                                                    <NavLink
                                                        // href={'#help'}
                                                        className={`nav-event-btn text-center`}
                                                        onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}>
                                                        Help
                                                    </NavLink>
                                                </Tooltip>
                                            </NavItem>

                                            {
                                                userType === 1 &&

                                                <div className="d-none d-lg-flex d-md-flex align-items-center justify-content-center ml-lg-4 w-100"
                                                     style={{alignItems: "center"}}>
                                                    <div>
                                                        <div className="user_name">
                                                            <b className={'more-nav'}>More</b>
                                                        </div>
                                                    </div>
                                                    <AppHeaderDropdown direction="down">
                                                        <DropdownToggle nav>
                                                            <div style={{
                                                                width: '45px',
                                                                height: '45px',
                                                                marginTop: '20px',
                                                                borderRadius: '50px',
                                                                alignContent: "center",
                                                                color: "black"
                                                            }}>
                                                                <ChevronDown size={24}/>
                                                            </div>
                                                        </DropdownToggle>
                                                        <DropdownMenu id={'moreDropDownMenu'}>
                                                            <DropdownItem className={`nav-event-btn nav-event-width`}
                                                                          onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>
                                                                {language[lang].MyClass}
                                                            </DropdownItem>
                                                            <DropdownItem className={`nav-event-btn nav-event-width`}
                                                                          onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}
                                                            >
                                                                {language[lang].MyLessons}
                                                            </DropdownItem>
                                                            <DropdownItem className={`nav-event-btn nav-event-width`}
                                                                          onClick={() => this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}>
                                                                {language[lang].MyCourses}
                                                            </DropdownItem>
                                                            <DropdownItem className={`nav-event-btn nav-event-width`}
                                                                          onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>
                                                                {language[lang].Exams}
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </AppHeaderDropdown>
                                                </div>
                                            }
                                        </div>

                                        {/*{*/}
                                        {/*    <NavItem className={"d-lg-block w-100"}>*/}
                                        {/*        <Tooltip title='Home Page'>*/}
                                        {/*            <NavLink*/}
                                        {/*                className={`nav-event-btn`}*/}
                                        {/*                onClick={() => this.props.history.push('/')}*/}
                                        {/*            >*/}
                                        {/*                {language[lang].HomePage}*/}
                                        {/*            </NavLink>*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </NavItem>*/}
                                        {/*}*/}
                                        {/*{*/}
                                        {/*    userType === 1 &&*/}
                                        {/*    <NavItem className={"d-lg-block w-100"}>*/}
                                        {/*        <Tooltip title='Enrolled Classes'>*/}
                                        {/*            <NavLink*/}
                                        {/*                className={`nav-event-btn`}*/}
                                        {/*                onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*/}
                                        {/*                {language[lang].MyClass}*/}
                                        {/*            </NavLink>*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </NavItem>*/}
                                        {/*}*/}
                                        {/*{*/}
                                        {/*    userType === 1 &&*/}
                                        {/*    <NavItem className={" d-lg-block w-100"}>*/}
                                        {/*        <Tooltip title='Enrolled Lessons'>*/}
                                        {/*            <NavLink*/}
                                        {/*                className={`nav-event-btn`}*/}
                                        {/*                onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>*/}
                                        {/*                {language[lang].MyLessons}*/}
                                        {/*            </NavLink>*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </NavItem>*/}
                                        {/*}*/}
                                        {/*{*/}
                                        {/*    //Courses*/}
                                        {/*    userType === 1 &&*/}
                                        {/*    <NavItem className={" d-lg-block w-100"}>*/}
                                        {/*        <Tooltip title='Enrolled Courses'>*/}
                                        {/*            <NavLink*/}
                                        {/*                className={`nav-event-btn`}*/}
                                        {/*                onClick={() =>*/}
                                        {/*                    this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}*/}
                                        {/*            >*/}
                                        {/*                {language[lang].MyCourses}*/}
                                        {/*            </NavLink>*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </NavItem>*/}
                                        {/*}*/}
                                        {/*{*/}
                                        {/*    userType === 1 &&*/}
                                        {/*    <NavItem className=" d-lg-block w-100">*/}
                                        {/*        <Tooltip title='Exams'>*/}
                                        {/*            <NavLink*/}
                                        {/*                className={`nav-event-btn`}*/}
                                        {/*                onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>*/}
                                        {/*                {language[lang].Exams}*/}
                                        {/*            </NavLink>*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </NavItem>*/}
                                        {/*}*/}


                                        {/*{userType !== 1 && webConfig.instituteType === constants.INSTITUTE ?*/}
                                        {/*    <NavItem className=" d-lg-block w-100">*/}
                                        {/*        <Tooltip title='Teachers'>*/}
                                        {/*            <NavLink*/}
                                        {/*                href='#teachersSection'*/}
                                        {/*                className={`nav-event-btn`}*/}
                                        {/*                onClick={() => this.reRouteWithId('#teachersSection')}*/}
                                        {/*            >*/}
                                        {/*                Teachers*/}
                                        {/*            </NavLink>*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </NavItem> : null*/}
                                        {/*}*/}

                                        {/*{userType !== 1 && <NavItem className=" d-lg-block w-100">*/}
                                        {/*    <Tooltip title='Contact'>*/}
                                        {/*        <NavLink*/}
                                        {/*            className={`nav-event-btn`}*/}
                                        {/*            onClick={() => this.reRouteWithId('#inquiryForm')}*/}
                                        {/*            href={'#inquiryForm'}*/}
                                        {/*        >*/}
                                        {/*            Contact*/}
                                        {/*        </NavLink>*/}
                                        {/*    </Tooltip>*/}
                                        {/*</NavItem>}*/}

                                        {/*{userType !== 1 && <NavItem className=" d-lg-block w-100">*/}
                                        {/*    <Tooltip title='About'>*/}
                                        {/*        <NavLink*/}
                                        {/*            href={'#aboutUsSection'}*/}
                                        {/*            className={`nav-event-btn`}*/}
                                        {/*            onClick={() => this.reRouteWithId('#aboutUsSection')}*/}
                                        {/*        >*/}
                                        {/*            About*/}
                                        {/*        </NavLink>*/}
                                        {/*    </Tooltip>*/}
                                        {/*</NavItem>}*/}

                                        {/*<NavItem className="d-none d-lg-block">*/}
                                        {/*    <Tooltip title='Help'>*/}
                                        {/*        <NavLink*/}
                                        {/*            className={`nav-event-btn`}*/}
                                        {/*            onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}>*/}
                                        {/*            Help*/}
                                        {/*        </NavLink>*/}
                                        {/*    </Tooltip>*/}
                                        {/*</NavItem>*/}


                                        <div style={{flex: 1}} className={"d-lg-flex d-md-flex d-none justify-content-end"}>
                                            {webConfig.LMSStatus === 'LMS' && userType !== 1 ? <NavItem className={""}>
                                                    <Button
                                                        className='reg-btn-new '
                                                        onClick={() => this.setModalHandler("LOGIN")}
                                                    >
                                                        Register/Login
                                                    </Button>
                                                </NavItem> :
                                                null
                                            }

                                            {
                                                userType === 1 &&

                                                <div className="d-none d-lg-flex d-md-flex ml-lg-4"
                                                     style={{alignItems: "center"}}>
                                                    <div>
                                                        <div className="font-weight-bold user_name">
                                                            {this.props.userObj.name}</div>
                                                    </div>
                                                    <AppHeaderDropdown direction="down">
                                                        <DropdownToggle nav>
                                                            <div style={{
                                                                width: '45px',
                                                                height: '45px',
                                                                borderRadius: '50px',
                                                                alignContent: "center"
                                                            }}>
                                                                <img src={cornerImage} style={{height: '45px'}} alt="user"/>
                                                            </div>
                                                        </DropdownToggle>
                                                        <DropdownMenu className={"profile-dropdown-menu-align"}>
                                                            <DropdownItem
                                                                onClick={() => this.routeHandler(constants.HOME_PROFILE_ROUTE)}>
                                                                <i className="fa fa-cog"/>{language[lang].Profile}
                                                            </DropdownItem>
                                                            <DropdownItem onClick={this.logoutHandler}><i
                                                                className="fa fa-lock"/>{language[lang].Logout}</DropdownItem>
                                                        </DropdownMenu>
                                                    </AppHeaderDropdown>
                                                </div>
                                            }
                                        </div>


                                    </>}

                                    {/*{this.state.screenSize < 992 && this.state.screenSize >= 768 ?*/}
                                    {/*<>*/}
                                    {/*    <div style={{flex: 1}} className={"d-lg-flex d-md-flex d-none"}>*/}
                                    {/*        <NavItem className={"d-block"}>*/}
                                    {/*            <Tooltip title='Logo'>*/}
                                    {/*                <NavLink*/}
                                    {/*                    //style={{margin: '0 5rem 0 0'}}*/}
                                    {/*                    className={``}*/}
                                    {/*                    onClick={() => this.routeHandler(constants.HOME_INSTITUTE_ROUTE)}>*/}
                                    {/*                    <img style={{borderRadius: '50%', margin: '0 6rem 0 0'}}*/}
                                    {/*                         width={'60px'}*/}
                                    {/*                         src={Logo} alt=""/>*/}
                                    {/*                </NavLink>*/}
                                    {/*            </Tooltip>*/}
                                    {/*        </NavItem>*/}
                                    {/*    </div>*/}

                                    {/*    <div style={{flex: 5}} className={"d-lg-flex d-md-flex d-none align-items-center"}>*/}
                                    {/*        {*/}
                                    {/*            <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                    {/*                <Tooltip title='Home Page'>*/}
                                    {/*                    <NavLink*/}
                                    {/*                        href={"#home"}*/}
                                    {/*                        className={`nav-event-btn text-center`}*/}
                                    {/*                        onClick={() => this.reRouteWithId("#home")}*/}
                                    {/*                    >*/}
                                    {/*                        {language[lang].HomePage}*/}
                                    {/*                    </NavLink>*/}
                                    {/*                </Tooltip>*/}
                                    {/*            </NavItem>*/}
                                    {/*        }*/}
                                    {/*        {*/}
                                    {/*            userType === 1 &&*/}
                                    {/*            <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*/}
                                    {/*                <Tooltip title='Teachers'>*/}
                                    {/*                    <NavLink*/}
                                    {/*                        href='#teachersSection'*/}
                                    {/*                        className={`nav-event-btn text-center`}*/}
                                    {/*                        onClick={() => this.reRouteWithId('#teachersSection')}*/}
                                    {/*                    >*/}
                                    {/*                        Teachers*/}
                                    {/*                    </NavLink>*/}
                                    {/*                </Tooltip>*/}
                                    {/*            </NavItem>*/}
                                    {/*        }*/}
                                    {/*        /!*{*!/*/}
                                    {/*        /!*    userType === 1 &&*!/*/}
                                    {/*        /!*    <NavItem className={"d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*!/*/}
                                    {/*        /!*        <Tooltip title='Enrolled Classes'>*!/*/}
                                    {/*        /!*            <NavLink*!/*/}
                                    {/*        /!*                className={`nav-event-btn text-center`}*!/*/}
                                    {/*        /!*                onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*!/*/}
                                    {/*        /!*                {language[lang].MyClass}*!/*/}
                                    {/*        /!*            </NavLink>*!/*/}
                                    {/*        /!*        </Tooltip>*!/*/}
                                    {/*        /!*    </NavItem>*!/*/}
                                    {/*        /!*}*!/*/}
                                    {/*        /!*{*!/*/}
                                    {/*        /!*    userType === 1 &&*!/*/}
                                    {/*        /!*    <NavItem className={" d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*!/*/}
                                    {/*        /!*        <Tooltip title='Enrolled Lessons'>*!/*/}
                                    {/*        /!*            <NavLink*!/*/}
                                    {/*        /!*                className={`nav-event-btn text-center`}*!/*/}
                                    {/*        /!*                onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}>*!/*/}
                                    {/*        /!*                {language[lang].MyLessons}*!/*/}
                                    {/*        /!*            </NavLink>*!/*/}
                                    {/*        /!*        </Tooltip>*!/*/}
                                    {/*        /!*    </NavItem>*!/*/}
                                    {/*        /!*}*!/*/}
                                    {/*        /!*{*!/*/}
                                    {/*        /!*    //Courses*!/*/}
                                    {/*        /!*    userType === 1 &&*!/*/}
                                    {/*        /!*    <NavItem className={" d-lg-flex d-md-flex align-items-center justify-content-center w-100"}>*!/*/}
                                    {/*        /!*        <Tooltip title='Enrolled Courses'>*!/*/}
                                    {/*        /!*            <NavLink*!/*/}
                                    {/*        /!*                className={`nav-event-btn text-center`}*!/*/}
                                    {/*        /!*                onClick={() =>*!/*/}
                                    {/*        /!*                    this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}*!/*/}
                                    {/*        /!*            >*!/*/}
                                    {/*        /!*                {language[lang].MyCourses}*!/*/}
                                    {/*        /!*            </NavLink>*!/*/}
                                    {/*        /!*        </Tooltip>*!/*/}
                                    {/*        /!*    </NavItem>*!/*/}
                                    {/*        /!*}*!/*/}
                                    {/*        /!*{*!/*/}
                                    {/*        /!*    userType === 1 &&*!/*/}
                                    {/*        /!*    <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*!/*/}
                                    {/*        /!*        <Tooltip title='Exams'>*!/*/}
                                    {/*        /!*            <NavLink*!/*/}
                                    {/*        /!*                className={`nav-event-btn text-center`}*!/*/}
                                    {/*        /!*                onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>*!/*/}
                                    {/*        /!*                {language[lang].Exams}*!/*/}
                                    {/*        /!*            </NavLink>*!/*/}
                                    {/*        /!*        </Tooltip>*!/*/}
                                    {/*        /!*    </NavItem>*!/*/}
                                    {/*        /!*}*!/*/}


                                    {/*        {userType !== 1 && webConfig.instituteType === constants.INSTITUTE ?*/}
                                    {/*            <NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                    {/*                <Tooltip title='Teachers'>*/}
                                    {/*                    <NavLink*/}
                                    {/*                        href='#teachersSection'*/}
                                    {/*                        className={`nav-event-btn text-center`}*/}
                                    {/*                        onClick={() => this.reRouteWithId('#teachersSection')}*/}
                                    {/*                    >*/}
                                    {/*                        Teachers*/}
                                    {/*                    </NavLink>*/}
                                    {/*                </Tooltip>*/}
                                    {/*            </NavItem> : null*/}
                                    {/*        }*/}

                                    {/*        {userType !== 1 && <NavItem className="d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                    {/*            <Tooltip title='Contact'>*/}
                                    {/*                <NavLink*/}
                                    {/*                    className={`nav-event-btn text-center`}*/}
                                    {/*                    onClick={() => this.reRouteWithId('#inquiryForm')}*/}
                                    {/*                    href={'#inquiryForm'}*/}
                                    {/*                >*/}
                                    {/*                    Contact*/}
                                    {/*                </NavLink>*/}
                                    {/*            </Tooltip>*/}
                                    {/*        </NavItem>}*/}

                                    {/*        {<NavItem className=" d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                    {/*            <Tooltip title='About'>*/}
                                    {/*                <NavLink*/}
                                    {/*                    href={'#aboutUsSection'}*/}
                                    {/*                    className={`nav-event-btn text-center`}*/}
                                    {/*                    onClick={() => this.reRouteWithId('#aboutUsSection')}*/}
                                    {/*                >*/}
                                    {/*                    About*/}
                                    {/*                </NavLink>*/}
                                    {/*            </Tooltip>*/}
                                    {/*        </NavItem>}*/}

                                    {/*        <NavItem className="d-none d-lg-flex d-md-flex align-items-center justify-content-center w-100">*/}
                                    {/*            <Tooltip title='Help'>*/}
                                    {/*                <NavLink*/}
                                    {/*                    // href={'#help'}*/}
                                    {/*                    className={`nav-event-btn text-center`}*/}
                                    {/*                    onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}>*/}
                                    {/*                    Help*/}
                                    {/*                </NavLink>*/}
                                    {/*            </Tooltip>*/}
                                    {/*        </NavItem>*/}

                                    {/*        {*/}
                                    {/*            userType === 1 &&*/}

                                    {/*            <div className="d-none d-lg-flex d-md-flex align-items-center justify-content-center ml-lg-4 w-100"*/}
                                    {/*                 style={{alignItems: "center"}}>*/}
                                    {/*                <div>*/}
                                    {/*                    <div className="font-weight-bold user_name">*/}
                                    {/*                        <b>More</b>*/}
                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*                <AppHeaderDropdown direction="down">*/}
                                    {/*                    <DropdownToggle nav>*/}
                                    {/*                        <div style={{*/}
                                    {/*                            width: '45px',*/}
                                    {/*                            height: '45px',*/}
                                    {/*                            marginTop: '20px',*/}
                                    {/*                            borderRadius: '50px',*/}
                                    {/*                            alignContent: "center"*/}
                                    {/*                        }}>*/}
                                    {/*                            <ChevronDown size={24}/>*/}
                                    {/*                        </div>*/}
                                    {/*                    </DropdownToggle>*/}
                                    {/*                    <DropdownMenu right style={{right: 'auto'}}>*/}
                                    {/*                        <DropdownItem className={`nav-event-btn`}*/}
                                    {/*                                      onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}>*/}
                                    {/*                            {language[lang].MyClass}*/}
                                    {/*                        </DropdownItem>*/}
                                    {/*                        <DropdownItem className={`nav-event-btn`}*/}
                                    {/*                                      onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}*/}
                                    {/*                        >*/}
                                    {/*                            {language[lang].MyLessons}*/}
                                    {/*                        </DropdownItem>*/}
                                    {/*                        <DropdownItem className={`nav-event-btn`}*/}
                                    {/*                                      onClick={() => this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}>*/}
                                    {/*                            {language[lang].MyCourses}*/}
                                    {/*                        </DropdownItem>*/}
                                    {/*                        <DropdownItem className={`nav-event-btn`}*/}
                                    {/*                                      onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}>*/}
                                    {/*                            {language[lang].Exams}*/}
                                    {/*                        </DropdownItem>*/}
                                    {/*                    </DropdownMenu>*/}
                                    {/*                </AppHeaderDropdown>*/}
                                    {/*            </div>*/}
                                    {/*        }*/}


                                    {/*    </div>*/}


                                    {/*    <div style={{flex: 1}} className={"d-lg-flex d-md-flex d-none justify-content-end"}>*/}
                                    {/*        {webConfig.LMSStatus === 'LMS' && userType !== 1 ? <NavItem className={""}>*/}
                                    {/*                <Button*/}
                                    {/*                    className='reg-btn '*/}
                                    {/*                    onClick={() => this.setModalHandler("LOGIN")}*/}
                                    {/*                >*/}
                                    {/*                    Register/Login*/}
                                    {/*                </Button>*/}
                                    {/*            </NavItem> :*/}
                                    {/*            null*/}
                                    {/*        }*/}

                                    {/*        {*/}
                                    {/*            userType === 1 &&*/}

                                    {/*            <div className="d-none d-lg-flex d-md-flex ml-lg-4"*/}
                                    {/*                 style={{alignItems: "center"}}>*/}
                                    {/*                <div>*/}
                                    {/*                    <div className="font-weight-bold user_name">*/}
                                    {/*                        {this.props.userObj.name}</div>*/}
                                    {/*                </div>*/}
                                    {/*                <AppHeaderDropdown direction="down">*/}
                                    {/*                    <DropdownToggle nav>*/}
                                    {/*                        <div style={{*/}
                                    {/*                            width: '45px',*/}
                                    {/*                            height: '45px',*/}
                                    {/*                            borderRadius: '50px',*/}
                                    {/*                            alignContent: "center"*/}
                                    {/*                        }}>*/}
                                    {/*                            <img src={cornerImage} style={{height: '45px'}} alt="user"/>*/}
                                    {/*                        </div>*/}
                                    {/*                    </DropdownToggle>*/}
                                    {/*                    <DropdownMenu className={"profile-dropdown-menu-align"}>*/}
                                    {/*                        <DropdownItem*/}
                                    {/*                            onClick={() => this.routeHandler(constants.HOME_PROFILE_ROUTE)}>*/}
                                    {/*                            <i className="fa fa-cog"/>{language[lang].Profile}*/}
                                    {/*                        </DropdownItem>*/}
                                    {/*                        <DropdownItem onClick={this.logoutHandler}><i*/}
                                    {/*                            className="fa fa-lock"/>{language[lang].Logout}</DropdownItem>*/}
                                    {/*                    </DropdownMenu>*/}
                                    {/*                </AppHeaderDropdown>*/}
                                    {/*            </div>*/}
                                    {/*        }*/}
                                    {/*    </div>*/}


                                    {/*</> : null}*/}

                                    {/*mobile view start*/}
                                    {
                                        userType === 0 && this.state.screenSize <= 767 ?
                                            <NavItem className="d-lg-none d-md-none mb-4 w-100  ">

                                                <Tooltip title='Home Page'>
                                                    <NavLink
                                                        style={{textTransform: 'capitalize'}}
                                                        onClick={() => this.reRouteWithId('#home')}
                                                        className={`w-100 login-btn  nav-event-btn text-center`}
                                                        color="default"
                                                        href={'#home'}
                                                    >
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].HomePage}</span>
                                                    </NavLink>
                                                </Tooltip>


                                                {webConfig.instituteType === constants.INSTITUTE ?
                                                    <Tooltip title='Teachers'>
                                                        <NavLink
                                                            style={{textTransform: 'capitalize'}}
                                                            href='#teachersSection'
                                                            className={`w-100 login-btn  nav-event-btn text-center`}
                                                            onClick={() => this.reRouteWithId('#teachersSection')}
                                                        >
                                                            Teachers
                                                        </NavLink>
                                                    </Tooltip> : null}

                                                <Tooltip title='Contact'>
                                                    <NavLink
                                                        style={{textTransform: 'capitalize'}}
                                                        className={`w-100 login-btn  nav-event-btn text-center`}
                                                        onClick={() => this.reRouteWithId('#inquiryForm')}
                                                        href={'#inquiryForm'}
                                                    >
                                                        Contact
                                                    </NavLink>
                                                </Tooltip>

                                                <Tooltip title='About'>
                                                    <NavLink
                                                        style={{textTransform: 'capitalize'}}
                                                        href={'#aboutUsSection'}
                                                        className={`w-100 login-btn nav-event-btn text-center`}
                                                        onClick={() => this.reRouteWithId('#aboutUsSection')}
                                                    >
                                                        About
                                                    </NavLink>
                                                </Tooltip>
                                                <Tooltip title='Help'>
                                                    <NavLink
                                                        style={{textTransform: 'capitalize'}}
                                                        className={`w-100 login-btn nav-event-btn text-center`}
                                                        onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}
                                                        // href={'#help'}
                                                    >
                                                        Help
                                                    </NavLink>
                                                </Tooltip>

                                                <Button
                                                    className='w-100 reg-btn justify-content-center '
                                                    onClick={() => this.setModalHandler("LOGIN")}
                                                >
                                                    Register/Login
                                                </Button>

                                            </NavItem>

                                            : <NavItem className="d-lg-none d-md-none mb-4 w-100">

                                                <Row>
                                                    <Col xs={6} sm={6} md={6}>
                                                        <Tooltip title='Home Page'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                onClick={() => this.reRouteWithId('#home')}
                                                                className={`w-100 login-btn  nav-event-btn text-center`}
                                                                color="default"
                                                                href={'#home'}
                                                            >
                                                        <span
                                                            className="nav-link-inner--text">{language[lang].HomePage}</span>
                                                            </NavLink>
                                                        </Tooltip>

                                                        <Tooltip title='Enrolled classes'>


                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                onClick={() => this.routeHandler(constants.HOME_MY_CLASS_ROUTE)}
                                                                className={`w-100 login-btn  nav-event-btn text-center`}
                                                                color="default">
                                                        <span
                                                            className="nav-link-inner--text">   {language[lang].MyClass}</span>
                                                            </NavLink>
                                                        </Tooltip>

                                                        <Tooltip title='Enrolled courses'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                onClick={() => this.routeHandler(constants.HOME_MY_COURSE_ROUTE)}
                                                                className={`w-100 login-btn  nav-event-btn text-center`}
                                                                color="default">
                                                        <span
                                                            className="nav-link-inner--text">   {language[lang].MyCourses}</span>
                                                            </NavLink>
                                                        </Tooltip>

                                                        <Tooltip title='Enrolled Lessons'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                onClick={() => this.routeHandler(constants.HOME_MY_LESSONS_ROUTE)}
                                                                className={`w-100 login-btn  nav-event-btn text-center`}
                                                                color="default">
                                                        <span
                                                            className="nav-link-inner--text">   {language[lang].MyLessons}</span>
                                                            </NavLink>
                                                        </Tooltip>

                                                        <Tooltip title='Exams'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                onClick={() => this.routeHandler(constants.HOME_EXAM_ROUTE)}
                                                                className={`w-100 login-btn  nav-event-btn text-center`}
                                                                color="default">
                                                        <span
                                                            className="nav-link-inner--text">   {language[lang].Exams}</span>
                                                            </NavLink>
                                                        </Tooltip>

                                                    </Col>
                                                    <Col xs={6} sm={6} md={6}>


                                                        {webConfig.instituteType === constants.INSTITUTE ?
                                                            <Tooltip title='Teachers'>
                                                                <NavLink
                                                                    style={{textTransform: 'capitalize'}}
                                                                    href='#teachersSection'
                                                                    className={`w-100 login-btn  nav-event-btn text-center`}
                                                                    onClick={() => this.reRouteWithId('#teachersSection')}
                                                                >
                                                                    Teachers
                                                                </NavLink>
                                                            </Tooltip> : null}

                                                        <Tooltip title='Contact'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                className={`w-100 login-btn  nav-event-btn text-center`}
                                                                onClick={() => this.reRouteWithId('#inquiryForm')}
                                                                href={'#inquiryForm'}
                                                            >
                                                                Contact
                                                            </NavLink>
                                                        </Tooltip>

                                                        <Tooltip title='About'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                href={'#aboutUsSection'}
                                                                className={`w-100 login-btn nav-event-btn text-center`}
                                                                onClick={() => this.reRouteWithId('#aboutUsSection')}
                                                            >
                                                                About
                                                            </NavLink>
                                                        </Tooltip>
                                                        <Tooltip title='Help'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                className={`w-100 login-btn nav-event-btn text-center`}
                                                                onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}
                                                                // href={'#help'}
                                                            >
                                                                Help
                                                            </NavLink>
                                                        </Tooltip>

                                                        <Tooltip title='Profile'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                className={`w-100 login-btn nav-event-btn text-center`}
                                                                onClick={() => this.routeHandler(constants.HOME_PROFILE_ROUTE)}
                                                            >
                                                                <Users/> {language[lang].Profile}
                                                            </NavLink>
                                                        </Tooltip>
                                                    </Col>

                                                    <Col xs={12} sm={12} md={12}>
                                                        <Tooltip title='Logout'>
                                                            <NavLink
                                                                style={{textTransform: 'capitalize'}}
                                                                className={`w-100  reg-btn nav-event-btn text-center`}
                                                                onClick={this.logoutHandler}
                                                            >
                                                                <LogOut/> {language[lang].Logout}
                                                            </NavLink>
                                                        </Tooltip>
                                                    </Col>

                                                </Row>


                                            </NavItem>
                                    }

                                </Nav>
                                {/*Nav btn section end*/}


                                {/*{
                                    userType === 1 &&

                                    <div className="d-none d-lg-flex ml-lg-4"
                                         style={{alignItems: "center"}}>
                                        <div>
                                            <div className="font-weight-bold user_name">
                                                <b> More</b>
                                            </div>
                                        </div>
                                        <AppHeaderDropdown direction="down">
                                            <DropdownToggle nav>
                                                <div style={{
                                                    width: '45px',
                                                    height: '45px',
                                                    marginTop: '20px',
                                                    borderRadius: '50px',
                                                    alignContent: "center"
                                                }}>
                                                    <ChevronDown size={24}/>
                                                </div>
                                            </DropdownToggle>
                                            <DropdownMenu right style={{right: 'auto'}}>
                                                <DropdownItem className={`nav-event-btn`}
                                                              onClick={() => this.reRouteWithId('#teachersSection')}>
                                                    Teacher
                                                </DropdownItem>
                                                <DropdownItem className={`nav-event-btn`}
                                                              onClick={() => this.reRouteWithId('#aboutUsSection')}
                                                >
                                                    About
                                                </DropdownItem>
                                                <DropdownItem className={`nav-event-btn`}
                                                              onClick={() => this.reRouteWithId('#inquiryForm')}>
                                                    Contact
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </AppHeaderDropdown>
                                    </div>
                                }*/}

                                {/*{*/}
                                {/*    userType === 1 &&*/}

                                {/*    <div className="d-none d-lg-flex ml-lg-4"*/}
                                {/*         style={{alignItems: "center"}}>*/}
                                {/*        <div>*/}
                                {/*            <div className="font-weight-bold user_name">*/}
                                {/*                {this.props.userObj.name}</div>*/}
                                {/*        </div>*/}
                                {/*        <AppHeaderDropdown direction="down">*/}
                                {/*            <DropdownToggle nav>*/}
                                {/*                <div style={{*/}
                                {/*                    width: '45px',*/}
                                {/*                    height: '45px',*/}
                                {/*                    borderRadius: '50px',*/}
                                {/*                    alignContent: "center"*/}
                                {/*                }}>*/}
                                {/*                    <img src={cornerImage} style={{height: '45px'}} alt="user"/>*/}
                                {/*                </div>*/}
                                {/*            </DropdownToggle>*/}
                                {/*            <DropdownMenu right style={{right: 'auto'}}>*/}
                                {/*                <DropdownItem*/}
                                {/*                    onClick={() => this.routeHandler(constants.HOME_PROFILE_ROUTE)}>*/}
                                {/*                    <i className="fa fa-cog"/>{language[lang].Profile}*/}
                                {/*                </DropdownItem>*/}
                                {/*                <DropdownItem onClick={this.logoutHandler}><i*/}
                                {/*                    className="fa fa-lock"/>{language[lang].Logout}</DropdownItem>*/}
                                {/*            </DropdownMenu>*/}
                                {/*        </AppHeaderDropdown>*/}
                                {/*    </div>*/}
                                {/*}*/}


                            </UncontrolledCollapse>
                        </div>
                    </Navbar>
                </header>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    userObj: state.student.userObj
});
const mapDispatchToProps = (dispatch) => ({
    setUserType: data => dispatch(actionCreator.setUserType(data)),
    selectPagination: data => dispatch(actionClassCreator.selectPagination(data)),
    selectMyClassPagination: data => dispatch(actionClassCreator.selectMyClassPagination(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DemoNavbar));
